import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import styles from './PodInfo.module.sass'
import { useMemo } from 'react'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

const PodInfo = ({ pod }) => {
	const { i18n } = useGlobal()
	const { phase, hasErrors, hasWarns, date, service, withTimeouts } = pod

	const phaseClassname = useMemo(() => {
		switch (phase.toLowerCase()) {
			case 'running':
				return styles['--running']
			case 'pending':
				return styles['--pending']
			case 'succeeded':
				return styles['--succeeded']
			case 'failed':
				return styles['--failed']

			default:
				return styles['--unknown']
		}
	}, [phase])

	const alertStatusClassname = useMemo(() => {
		if (hasErrors) {
			return styles['--has-errors']
		}
		if (hasWarns) {
			return styles['--has-warnings']
		}
	}, [hasErrors, hasWarns])

	return (
		<tr>
			<th scope='row' className={styles['pod-info-item']}>
				{service}
			</th>
			<td className={styles['pod-info-item']}>
				<VStack align='center' className={styles['flex-col']}>
					{date.fromNow}
					<small className={styles['pod-created-date']}>
						({date.dateTimeFormat})
					</small>
				</VStack>
			</td>
			<td className={styles['pod-info-item']}>
				<PodPhase
					phase={i18n.translate(phase.toLowerCase())}
					className={phaseClassname}
				/>
			</td>
			<td className={`${styles['pod-info-item']} ${styles['--flex']}`}>
				<PodAlertStatus className={alertStatusClassname} />
				{withTimeouts && <small>({i18n`With timeouts`})</small>}
			</td>
		</tr>
	)
}

const PodPhase = ({ phase, className }) => {
	return (
		<VStack className={`${styles['pod-info']} ${className}`}>
			<small>{phase}</small>
		</VStack>
	)
}

const Point = () => (
	<svg width='24px' height='24px' xmlns='http://www.w3.org/2000/svg'>
		<circle cx='12' cy='12' r='10' fill='currentColor' />
	</svg>
)

const PodAlertStatus = ({ className }) => {
	return (
		<VStack className={`${styles['pod-info']} ${className}`}>
			<Point />
		</VStack>
	)
}

export default PodInfo
